import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import {
  AlbumFolderWithChildrenAndSubscription,
  AlbumFolderHierarchy,
} from '../../graphql/queries/album-folder';
import {
  onSelectAlbum,
  onDeselectAlbum,
  onResetIdentity,
  onSelectIdentity,
  onSelectAlbumCustomPrint,
  onDeselectAlbumCustomPrint,
} from '../../actions/discover-album-folder';
import { closeModal, openModal } from '../../actions/modal-actions';
import DiscoverAlbumFolder from '../../components/discover/DiscoverAlbumFolder';
import { MeWithIdentities } from '../../apps/consumer/graphql/queries/account';
import { setActiveIdentity } from '../../services/checkout/redux/checkoutActions';

const withUserData = graphql(MeWithIdentities, {
  props: ({ data: { me } }) => ({
    account: me,
  }),
});

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  identity: discoverAlbumFolder.identities.find(
    identity => identity.id === discoverAlbumFolder.currentIdentityId,
  ),
  selectedIdentities: discoverAlbumFolder.identities,
  selectedIdentityId: discoverAlbumFolder.currentIdentityId,
  albumFolderId: discoverAlbumFolder.albumFolderId,
  allowsJoinTypeSelection: discoverAlbumFolder.allowsJoinTypeSelection,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSelectAlbum: album =>
    dispatch(
      onSelectAlbum({
        ...album,
        albumFolderHierarchy: ownProps.albumFolderHierarchy, // Add hierarchy to the album.
      }),
    ),
  onDeselectAlbum: album => dispatch(onDeselectAlbum(album)),
  onSelectAlbumCustomPrint: albumCustomPrint =>
    dispatch(onSelectAlbumCustomPrint(albumCustomPrint)),
  onDeselectAlbumCustomPrint: (albumCustomPrint, identityId) =>
    dispatch(onDeselectAlbumCustomPrint(albumCustomPrint, identityId)),
  onResetIdentity: () => dispatch(onResetIdentity()),
  onSelectIdentity: (identity, joinType) => {
    dispatch(onSelectIdentity(identity, joinType));
    dispatch(setActiveIdentity(identity));
  },
  openModal: (...args) => dispatch(openModal(...args)),
  closeModal: name => dispatch(closeModal(name)),
});

const withAlbumFolder = graphql(AlbumFolderWithChildrenAndSubscription, {
  options: ({ match, identity }) => ({
    variables: {
      id: match.params.albumFolderId,
      identity_id: identity && identity.id,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
});

const withAlbumFolderHierarchy = graphql(AlbumFolderHierarchy, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
      // @TODO Bring this back once the filter has been implemented for AlbumFoolderChildren.album_folders
      // joins_enabled_only: true,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => {
    if (albumFolder) {
      const currentAlbumFolder = {
        ...albumFolder,
        album_folder_hierarchy: undefined,
      };

      const hierarchyWithRoot = [
        currentAlbumFolder,
        ...get(albumFolder, 'album_folder_hierarchy.records', []),
      ].reverse();

      const [rootAlbumFolder, ...albumFolderHierarchy] = hierarchyWithRoot;

      return {
        loading,
        rootAlbumFolder,
        albumFolderHierarchy,
      };
    }

    return {
      loading,
    };
  },
});

export default compose(
  withRouter,
  withUserData,
  withAlbumFolderHierarchy,
  // The order here is important as the `identity` from `mSTP` is
  // passed to `withAlbumFolder`
  connect(mapStateToProps, mapDispatchToProps),
  withAlbumFolder,
)(DiscoverAlbumFolder);
